// extracted by mini-css-extract-plugin
export var aircallIframe = "_iw-3";
export var fabContainer = "_iw-5";
export var fabRinging = "_iw-6";
export var loadingOverlay = "_iw-4";
export var pulse = "_iw-7";
export var widgetContent = "_iw-2";
export var widgetPanel = "_iw-0";
export var widgetPanelExpanded = "_iw-1";